// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa .\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__title-t5hBAu.semi-dropdown-title {
  padding: 8px 12px;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa .\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__menu-RY4m9s.semi-dropdown-menu {
  max-width: 480px;
  padding: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa [role="menu"].semi-dropdown-menu {
  max-width: 480px;
  padding: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa .\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__menu-RY4m9s.semi-dropdown-menu .semi-dropdown-item:hover {
  background-color: rgba(28, 28, 35, .04);
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa [role="menu"].semi-dropdown-menu .semi-dropdown-item:hover {
  background-color: rgba(28, 28, 35, .04);
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa .\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__item-ZdMEET.semi-dropdown-item {
  max-width: unset;
  align-items: center;
  height: 40px;
  padding: 8px 12px;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa .\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__item-ZdMEET.semi-dropdown-item[aria-disabled="true"] {
  opacity: .4;
}

.\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa .\\------packages-components-bot-semi-src-components-ui-dropdown-index-module__item-ZdMEET.semi-dropdown-item .semi-icon {
  margin-right: 8px;
  font-size: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-dropdown": `------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa`,
	"uiDropdown": `------packages-components-bot-semi-src-components-ui-dropdown-index-module__ui-dropdown-Pa2rVa`,
	"title": `------packages-components-bot-semi-src-components-ui-dropdown-index-module__title-t5hBAu`,
	"menu": `------packages-components-bot-semi-src-components-ui-dropdown-index-module__menu-RY4m9s`,
	"item": `------packages-components-bot-semi-src-components-ui-dropdown-index-module__item-ZdMEET`
};
export default ___CSS_LOADER_EXPORT___;
